import api from "./apis";
import { ERROR_MESSAGE, LOADED, LOADING, SUCCESS_MESSAGE, VALIDATION_ERROR } from "./types";
import history from "../history";


export const getApis = () => async (dispatch) => {
  dispatch({ type: LOADING });
  try{
    let response = null;
    response = await api(localStorage.getItem("token")).get(`/setting-management/api`);
    // console.log(response)
    if(response.status === 200 ) {
      dispatch({ type: LOADED });
      return response.data.setting;
    }
  }
  catch( err ){
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
}


export const updateApi = (data) => async (dispatch) => {
  dispatch({ type: LOADING });
  let token = Object.keys(data)[0]
  try {
    const obj = {
      [Object.keys(data)[0]]: data[token],
      "password": data.password,
      "remark": data.remark,
    }
    const response = await api(localStorage.getItem("token")).patch("/setting-management/api", {...obj});
    // console.log(response)
    if (response.status === 201) {
      dispatch({
        type: SUCCESS_MESSAGE,
        payload: "Api successfully updated",
      });
      
      dispatch({ type: LOADED });
      return response.status
    } else {
      dispatch({ type: LOADED });
    }
  } catch (err) {
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
};


export const getLegalCheckList = (p,e,ds,de) => async (dispatch) => {
  dispatch({ type: LOADING });
  try{
    let response = null;
    if(ds && de){
      response = await api(localStorage.getItem("token")).get(`/client-management/health/check?p=${p?p:1}&e=${e?e:""}&ds=${ds}&de=${de}`);
    }
    else{
      response = await api(localStorage.getItem("token")).get(`/client-management/health/check?p=${p?p:1}&e=${e?e:""}`);
    }
      if(response.status === 200 ) {
      dispatch({ type: LOADED });
      return response.data;
    }
  }
  catch( err ){
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
}